import React from "react";
import { RowData } from "./types";

export const emailCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    const email = data.item.purchase.customerEmail;
    const guestEmail = data.guest?.traveler?.email;
    const emailField = data.guest?.formResponse?.fields.find((field) => /email/i.test(field.label));
    return data.isOrganizer ? email ?? "" : guestEmail ?? emailField?.value ?? "";
};

export const EmailCellRenderer = ({ value }: { value: string | null }) => (
    <span className="no-translate">{value ?? ""}</span>
);
